<template>
  <aside class="aside" :class="{ 'is-active': isActive }">
    <div class="aside__holder">
      <div class="aside-content">
        <div class="aside-content__body">
          <div class="aside-menu-layout">
            <nav class="aside-primary" aria-label="Продукция LITHIUM">
              <UiTypography
                class="aside-menu-label"
                tag="p"
                variant="caption"
              >
                Продукция LITHIUM
              </UiTypography>
              <ul class="aside-primary__list">
                <li v-for="item in primaryItems" :key="item.link">
                  <UiTextButton
                    variant="text-large"
                    :to="item.link"
                    exact
                    @click.native="close"
                  >
                    {{ item.title }}
                  </UiTextButton>
                </li>
              </ul>
            </nav>

            <div class="aside-secondary">
              <nav class="aside-menu-group" aria-label="Для профессионалов">
                <UiTypography
                  class="aside-menu-label"
                  tag="p"
                  variant="caption"
                >
                  Для профессионалов
                </UiTypography>
                <ul>
                  <li v-for="item in professionalItems" :key="item.link">
                    <UiTextButton
                      variant="text-medium"
                      :to="item.link"
                      exact
                      @click.native="close"
                    >
                      {{ item.title }}
                    </UiTextButton>
                  </li>
                </ul>
              </nav>

              <nav class="aside-menu-group" aria-label="Компания">
                <UiTypography
                  class="aside-menu-label"
                  tag="p"
                  variant="caption"
                >
                  Компания
                </UiTypography>
                <ul>
                  <li v-for="item in companyItems" :key="item.link">
                    <UiTextButton
                      variant="text-medium"
                      :to="item.link"
                      exact
                      @click.native="close"
                    >
                      {{ item.title }}
                    </UiTextButton>
                  </li>
                </ul>
              </nav>
            </div>

            <img
              class="aside-menu-image"
              :src="isMobileMenu ? null : require('@/assets/img/aside/menu-picture.png')"
              alt="Интерьер кухни LITHIUM"
            />

            <div class="aside-desktop-footer">
              <div class="aside-copyright">
                <UiTypography tag="span" variant="caption" tone="inherit">
                  © Lithium 2015 — {{ currentYear }}
                </UiTypography>
                <UiTypography tag="span" variant="caption" tone="inherit">
                  Made in Russia, Kirov - Vyatka
                </UiTypography>
              </div>
              <ul class="aside-social" aria-label="Социальные сети">
                <li v-for="item in socialItems" :key="item.link">
                  <UiTextButton
                    class="aside-social__link"
                    variant="text-small"
                    :href="item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ item.title }}
                  </UiTextButton>
                </li>
              </ul>
            </div>

            <div class="aside-mobile-footer">
              <UiOutlineButton
                class="aside-application"
                theme="dark"
                to="/application"
                full-width
                @click.native="close"
              >
                Оставить заявку
              </UiOutlineButton>
              <div class="aside-mobile-copyright">
                <UiTypography tag="span" variant="caption" tone="inherit">
                  © Lithium 2015 - {{ currentYear }}
                </UiTypography>
                <UiTypography tag="span" variant="caption" tone="inherit">
                  Made in Russia, Kirov - Vyatka
                </UiTypography>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="aside-panel">
        <button
          class="aside-panel__button"
          type="button"
          :aria-label="isActive ? 'Закрыть меню' : 'Открыть меню'"
          @click="toggle"
        >
          <span class="burger" :class="{ isOpened: isActive }">
            <span class="stripe stripe--1" />
            <span class="stripe stripe--2" />
            <span class="stripe stripe--3" />
          </span>
        </button>

        <transition name="fade">
          <scroll-indicator v-if="!isActive" :isScrolled="isScrolled" />
        </transition>
      </div>
    </div>
  </aside>
</template>

<script>
import ScrollIndicator from '../ScrollIndicator'
import { maxWidth, watchMaxWidth, sassVariables } from '@/utils'
import {
  UiOutlineButton,
  UiTextButton,
  UiTypography
} from '@/components/common/ui'

export default {
  name: 'Aside',
  components: {
    ScrollIndicator,
    UiOutlineButton,
    UiTextButton,
    UiTypography
  },
  props: {
    isScrolled: {
      type: Boolean,
      default: false
    }
  },
  data (vm) {
    return {
      isMobileMenu: maxWidth(sassVariables.mobile),
      unwatchMenuWidth: watchMaxWidth(sassVariables.mobile, ({ matches }) => {
        vm.isMobileMenu = matches
      }),
      primaryItems: [
        { title: 'Кухни', link: '/products/kitchens' },
        { title: 'Гардеробные', link: '/products/wardrobes' },
        { title: 'Диваны', link: '/products/sofas' },
        { title: 'Керамика', link: '/ceramics' },
        { title: 'Вся продукция', link: '/products' },
        { title: 'Дизайн', link: '/design' }
      ],
      professionalItems: [
        { title: 'Партнёрская программа', link: '/friends' },
        { title: 'Контрактное направление', link: '/contract' }
      ],
      companyItems: [
        { title: 'О фабрике', link: '/brand' },
        { title: 'Шоурумы', link: '/contacts' },
        { title: 'Сервис', link: '/service' }
      ],
      socialItems: [
        { title: 'Instagram', link: 'https://instagram.com/lithium_kitchen' },
        { title: 'Telegram', link: 'https://telegram.me/lithiumhome' },
        { title: 'YouTube', link: 'https://www.youtube.com/@lithiumhome' },
        { title: 'Pinterest', link: 'https://pinterest.com/Lithium_kitchen/' },
        { title: 'ВКонтакте', link: 'https://vk.com/lithium_kitchen' }
      ]
    }
  },
  computed: {
    isActive () {
      return this.$store.getters['ui/aside'].active
    },
    currentYear () {
      return new Date().getFullYear()
    }
  },
  mounted () {
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy () {
    this.unwatchMenuWidth()
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    toggle () {
      this.$store.commit('ui/toggleAside')
    },
    close () {
      this.$store.commit('ui/toggleAside', false)
    },
    onKeydown (event) {
      if (event.keyCode === 27 && this.isActive) this.close()
    }
  }
}
</script>

<style lang="scss">
.aside {
  position: fixed;
  inset: 0;
  z-index: 9;
  width: 100%;
  background: #fff;
  transform: translateX(calc(-100% + #{$aside-width}));
  transition: transform 1s $cubic-basic;

  &.is-active {
    z-index: 10;
    transform: translateX(0);
  }

  &__holder {
    display: flex;
    width: 100%;
    height: 100%;
  }

  &-content {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;

    &__body {
      width: 100%;
      height: 100%;
      color: #2e2e2e;
    }
  }

  &-menu-layout {
    position: relative;
    display: grid;
    grid-template-columns: vw(379) vw(20) vw(379) 1fr vw(512);
    width: 100%;
    height: 100%;
    padding: vw(130) vw(72) vw(130) vw(172);
  }

  &-primary {
    display: flex;
    flex-direction: column;
    gap: vw(24);
    grid-column: 1;
    padding-top: vw(2);

    &__list {
      display: flex;
      flex-direction: column;
      gap: vw(10);
    }
  }

  &-secondary {
    grid-column: 3;
    padding-top: vw(2);
  }

  &-menu-group {
    display: flex;
    flex-direction: column;
    gap: vw(24);

    ul {
      display: flex;
      flex-direction: column;
      gap: vw(10);
    }

    & + & {
      margin-top: vw(92);
    }
  }

  &-menu-image {
    grid-column: 5;
    align-self: stretch;
    width: 100%;
    height: 100%;
    min-height: 0;
    object-fit: cover;
  }

  &-desktop-footer {
    position: absolute;
    left: vw(172);
    bottom: vw(129);
    display: flex;
    align-items: center;
    gap: vw(36);
  }

  &-copyright {
    display: flex;
    gap: vw(32);
    color: #cdcdcd;
  }

  &-social {
    display: flex;
    gap: vw(32);

    & &__link {
      text-transform: none;
    }
  }

  &-mobile-footer {
    display: none;
  }

  &-panel {
    position: relative;
    flex: 0 0 $aside-width;

    &::after {
      content: '';
      position: absolute;
      top: $header-height;
      right: 0;
      bottom: 0;
      width: 6px;
      box-shadow: 8px 0 12px 0 #0000000a;
      pointer-events: none;
    }

    &__button {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: vw(100);
      padding: 0;
      margin: vw(-35) auto 0;
      border: 0;
      background: transparent;
      transition: transform 0.35s ease-out, fill 0.25s ease-out;
      cursor: pointer;

      &:hover {
        .burger:not(.isOpened) .stripe {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .burger {
    position: relative;
    display: block;
    width: vw(38);
    height: vw(24);
    transition: transform 0.3s ease;

    @include max-width(lg) {
      width: 38px;
      height: 24px;
    }

    @include max-width(md-lg) {
      width: 32px;
      height: 20px;
    }

    @include max-width(md) {
      width: 24px;
      height: 16px;
    }
  }

  .stripe {
    position: absolute;
    left: 0;
    right: 0;
    width: calc(100% - #{vw(4)});
    height: 2px;
    margin: 0 2px;
    background: #2c2c2c;
    transition: opacity 0.15s linear, transform 0.3s ease,
      width 0.3s ease, margin 0.3s ease, left 0.3s ease;

    @include max-width(lg) {
      width: calc(100% - 4px);
    }

    @include max-width(md) {
      height: 1px;
    }

    &--1 {
      top: 0;
      transform-origin: top left;
    }

    &--2 {
      top: vw(11);

      @include max-width(lg) {
        top: 11px;
      }

      @include max-width(md-lg) {
        top: 9px;
      }

      @include max-width(md) {
        top: 8px;
      }
    }

    &--3 {
      bottom: 0;
      transform-origin: bottom left;
    }
  }

  .isOpened {
    .stripe {
      width: vw(31.11);
      left: vw(8);

      @include max-width(lg) {
        width: 32px;
        left: 8px;
      }

      @include max-width(md-lg) {
        width: 26.3px;
        left: 7px;
      }

      @include max-width(md) {
        width: 21.63px;
        left: 6px;
      }

      &--1 {
        transform: rotate(45deg);
      }

      &--2 {
        opacity: 0;
      }

      &--3 {
        transform: rotate(-45deg);
      }
    }

    &:hover {
      transform: scale(1.1);
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

@include max-width(mobile) {
  .aside {
    top: $header-mob;
    z-index: 10;
    height: calc(100% - #{$header-mob});
    transform: translateX(-100%);

    &.is-active {
      z-index: 10;
      transform: translateX(0);
    }

    &-content__body {
      overflow-x: hidden;
      overflow-y: auto;
    }

    &-menu-layout {
      display: flex;
      flex-direction: column;
      min-height: 100%;
      padding: vwm(32) vwm(18) 0;
    }

    &-menu-label,
    &-menu-image,
    &-desktop-footer,
    &-panel {
      display: none;
    }

    &-primary__list {
      gap: vwm(10);
    }

    &-primary {
      gap: vwm(24);
      padding-top: 0;
    }

    &-secondary {
      display: flex;
      flex-direction: column;
      gap: vwm(10);
      margin-top: vwm(64);
      padding-top: 0;
    }

    &-menu-group {
      gap: vwm(24);

      ul {
        gap: vwm(10);
      }

      & + & {
        margin-top: 0;
      }
    }

    &-mobile-footer {
      display: block;
      margin-top: vwm(64);
      padding-bottom: vwm(32);
    }

    &-application {
      width: 100%;
      margin-bottom: vwm(32);
    }

    &-mobile-copyright {
      display: flex;
      justify-content: space-between;
      color: #999;
    }
  }
}
</style>
